import React, { Fragment } from 'react';
import Helmet from 'react-helmet';

import { search } from '~/state/ducks/organizations/operations';

import Search from '~/views/common/Search';
import Heading from '~/views/common/Heading';


const filters = ['portals', 'archived', 'deleted'];


const Organizations = () => (
    <Fragment>
        <Helmet title="Organizations" />

        <Heading
            header="Organizations"
            subheader="Search"
            iconName="university"
        />

        <Search
            placeholder="Name / ID"
            onSubmit={search}
            filters={filters}
        />
    </Fragment>
);

export default Organizations;
